import React, { useEffect, useRef, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { API, useAuth } from "@/App";
import { useLocale } from "@/context/LocaleContext";
import { AccountMenu } from "@/components/AccountMenu";
import { joinProjectByInvite } from "@/lib/inviteJoin";
import { toast } from "sonner";
import { PROJECTS_LIST_PATH } from "@/lib/routes";

export default function JoinInvitePage() {
  const { inviteCode: rawCode } = useParams();
  const inviteCode = rawCode ? decodeURIComponent(rawCode) : "";
  const { user } = useAuth();
  const { t } = useLocale();
  const nav = useNavigate();
  const [joining, setJoining] = useState(false);
  const started = useRef(false);

  useEffect(() => {
    started.current = false;
  }, [inviteCode]);

  useEffect(() => {
    if (!inviteCode || user === null || user === false) return;
    if (started.current) return;
    started.current = true;
    setJoining(true);
    (async () => {
      try {
        const pid = await joinProjectByInvite(API, inviteCode);
        localStorage.removeItem("pending_invite_code");
        toast.success(t("invite.joinOk"));
        nav(`/project/${pid}`, { replace: true });
      } catch (e) {
        started.current = false;
        setJoining(false);
        const st = e?.response?.status;
        const detail = e?.response?.data?.detail;
        toast.error(typeof detail === "string" ? detail : st === 404 ? t("invite.invalid") : t("invite.joinFailed"));
        nav(PROJECTS_LIST_PATH, { replace: true });
      }
    })();
  }, [user, inviteCode, nav, t]);

  if (!inviteCode) {
    return <Navigate to="/login" replace />;
  }

  if (user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--bg)] text-[var(--text-dim)] px-4 relative">
        <div className="absolute top-4 right-4">
          <AccountMenu helpReturnTo="/login" />
        </div>
        <p className="mt-8">{t("common.loading")}</p>
      </div>
    );
  }

  if (user === false) {
    try {
      localStorage.setItem("pending_invite_code", inviteCode);
    } catch {}
    return <Navigate to={`/login?invite=${encodeURIComponent(inviteCode)}`} replace />;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--bg)] text-[var(--text-dim)] px-4 relative">
      <div className="absolute top-4 right-4">
        <AccountMenu helpReturnTo="/login" />
      </div>
      <p className="mt-8 text-sm">{joining ? t("invite.joining") : t("common.loading")}</p>
    </div>
  );
}
